import { render, staticRenderFns } from "./MessageHistoryFamilyList.vue?vue&type=template&id=3c46434c&scoped=true&lang=pug"
import script from "./MessageHistoryFamilyList.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryFamilyList.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryFamilyList.vue?vue&type=style&index=0&id=3c46434c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46434c",
  null
  
)

export default component.exports